package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.Arrangement.spacedBy
import androidx.compose.foundation.layout.Column
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import com.karawek.core.ui.components.CoreList
import com.karawek.core.ui.components.CoreListItem
import com.karawek.core.ui.components.CoreNavRow
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogLists() {
    Column(verticalArrangement = spacedBy(CoreSpacing.lg)) {

        Text("Lists", style = CoreTypography.title)

        CoreList {
            CoreListItem(
                text = "Simple list item",
                onClick = {},
            )

            CoreListItem(
                text = "Another item",
                onClick = {},
            )
        }

        Text("Navigation Rows", style = CoreTypography.bodySecondary)

        CoreList {
            CoreNavRow(
                text = "Profile",
                onClick = {},
            )

            CoreNavRow(
                text = "Settings",
                onClick = {},
            )
        }
    }
}
